import { Link } from 'react-router-dom';
import { AppLink, PdfLink, UrlLink } from '../../../../model/models';
import { ServiceProps } from '../../../../pages/ServicesPage';
import { ModelsService } from '../../../../services/ModelsService';

interface AppLinkProps {
  link: AppLink;
}

export const APP_LINK_ICONS = {
  pdf: 'far fa-file-pdf',
  external_link: 'fas fa-arrow-right',
  service: 'fas fa-arrow-right',
};

export const AppLinkIcon: React.FC<AppLinkProps> = ({ link }) => {
  return (
    <div className=" p-5 flex justify-center items-center w-0 h-0 text-lg bg-primary text-white rounded-full">
      <i className={APP_LINK_ICONS[link.acf_fc_layout]} aria-hidden="true"></i>
    </div>
  );
};

export const AppLinkTitle: React.FC<{ children }> = ({ children }) => (
  <h3 className="text-black font-medium text-sm">{children}</h3>
);

export const AppLinkDiv: React.FC<{ children }> = ({ children }) => (
  <div className="flex-1 flex flex-row justify-between items-center p-6 py-5">
    {children}
  </div>
);

export const AppLinkPdf: React.FC<{ link: PdfLink; children }> = ({
  link,
  children,
}) => (
  <a href={link.link.url} rel="noreferrer" target="_blank">
    {children}
  </a>
);

export const AppLinkUrl: React.FC<{ link: UrlLink; children }> = ({
  link,
  children,
}) => (
  <a href={link.url} rel="noreferrer" target="_blank">
    {children}
  </a>
);

export const ServiceAppLink: React.FC<{ children }> = ({ children }) => {
  return (
    <li className="col-span-1 flex flex-col text-left bg-white border border-primary border-opacity-40 rounded-xl my-5">
      {children}
    </li>
  );
};

export const AppServiceLink: React.FC<ServiceProps> = ({
  service,
  children,
}) => {
  const link = ModelsService.getServiceFullSlug(service);
  return <Link to={link}>{children}</Link>;
};
